/**
 *
 * MeasurementDetailsTable
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
import { Table, Modal } from "antd"
import { debounce, has } from "lodash"
import alertSvg from "images/alert.svg"
import { columns } from "./columns"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class MeasurementDetailsTable extends React.Component {
  state = {
    rowSelected: {},
    modalResendSurvey: false,
    modalDeleteDivOrColl: false,
    resendSurveyTo: {},
    filteredInfo: null,
    sortedInfo: null,
  }

  componentDidUpdate(prevProps) {
    const { checkIncludeSubdivisions } = this.props
    if (prevProps.checkIncludeSubdivisions !== checkIncludeSubdivisions) {
      this.clearAll()
    }
  }

  setStateFrom = (values) => {
    this.setState(values)
  }

  debounceRowSelected = debounce((record) => {
    this.setState({ rowSelected: record })
  }, 50)

  handleChange = (pagination, filters, sorter) => {
    const { onTableChange } = this.props
    
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    })

    // Llamar al callback del padre para paginación backend
    if (onTableChange) {
      onTableChange(pagination, filters, sorter)
    }
  }

  clearAll = () => {
    this.setState({
      filteredInfo: null,
      sortedInfo: null,
    })
  }

  tableDetail = (
    idStatus,
    loading,
    rowSelected,
    checkIncludeSubdivisions,
    sortedInfo,
    filteredInfo
  ) => {
    const { expandedRowKeys, onExpandedRowsChange } = this.props
    return (
      <Table
        bordered
        size="small"
        className={`measurement-details-table${idStatus == 5 ? "" : " add-style-three-column"
          }`}
        rowKey={(record) => {
          if (record.id_employee) {
            return `employee_${record.id_employee}`
          }
          return `division_${record.id_division}`
        }}
        expandedRowKeys={expandedRowKeys}
        onExpandedRowsChange={onExpandedRowsChange}
        onRow={(record) => {
          return {
            onMouseEnter: () => this.debounceRowSelected(record),
            onMouseLeave: () => this.debounceRowSelected({}),
          }
        }}
        loading={loading}
        columns={columns(
          idStatus,
          this.props.onlyEnps,
          rowSelected,
          this.setStateFrom,
          checkIncludeSubdivisions,
          sortedInfo,
          filteredInfo,
          this.props.measureStatus.active_resend
        )}
        dataSource={this.props.data}
        pagination={{
          current: this.props.pagination?.current_page || 1,
          pageSize: this.props.pagination?.per_page || 15,
          total: this.props.pagination?.total || 0,
          pageSizeOptions: ["15", "25", "50", "100"],
          showSizeChanger: true,
          size: "default",
        }}
        onChange={this.handleChange}
      />
    )
  }

  render() {
    const {
      idStatus,
      loading,
      deleteCollDivWatcher,
      resendCollDivWatcher,
      checkIncludeSubdivisions,
      measureStatus
    } = this.props
    const {
      rowSelected,
      modalResendSurvey,
      resendSurveyTo,
      modalDeleteDivOrColl,
      sortedInfo,
      filteredInfo,
    } = this.state

    return (
      <Fragment>
        {this.tableDetail(
          idStatus,
          loading,
          rowSelected,
          checkIncludeSubdivisions,
          sortedInfo,
          filteredInfo
        )}
        <Modal
          visible={modalResendSurvey}
          okText="Reenviar"
          cancelText="Cancelar"
          bodyStyle={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
          afterClose={() => this.setState({ resendSurveyTo: {} })}
          onOk={() => {
            const {
              match: { params },
            } = this.props
            const paramsInfo = {
              idMeasure: params.id,
              idEmployee: resendSurveyTo.id_employee,
              idDivision: resendSurveyTo.id_division,
            }
            resendCollDivWatcher(paramsInfo)
            this.setState({ modalResendSurvey: false })
            this.forceUpdate()
          }}
          onCancel={() => {
            this.setState({ modalResendSurvey: false })
          }}
          width={520}>
          <img src={alertSvg} className="alertIcon" style={{ height:30 }} />
          <span style={{ marginTop: 16, fontSize: 14 }}>
            ¿Estás seguro de que deseas reenviar la encuesta a:{" "}
            <strong>{resendSurveyTo.full_name || resendSurveyTo.name}</strong>?
          </span>
          {!resendSurveyTo.id_employee && (
            <p style={{ fontSize: 13, marginTop: 8, marginBottom: 0 }}>
              Esta será reenviada <strong>únicamente</strong> a aquellos
              colaboradores que aún no la han contestado y tienen un correo asociado.
            </p>
          )}
        </Modal>

        <Modal
          visible={modalDeleteDivOrColl}
          okText="Eliminar"
          cancelText="Cancelar"
          bodyStyle={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
          afterClose={() => this.setState({ resendSurveyTo: {} })}
          onOk={() => {
            const {
              match: { params },
            } = this.props
            const paramsInfo = {
              idMeasure: params.id,
              idSurveyType: this.props.idSurveyType,
              idEmployee: resendSurveyTo.id_employee,
              idDivision: resendSurveyTo.id_division,
            }

            deleteCollDivWatcher(paramsInfo)
            this.setState({ modalDeleteDivOrColl: false })
          }}
          onCancel={() => {
            this.setState({ modalDeleteDivOrColl: false })
          }}
          width={520}>
          <img src={alertSvg} style={{ maxHeight: "30px" }} />
          <span style={{ marginTop: 16, fontSize: 14 }}>
            {`¿Estás seguro de que deseas eliminar
              ${has(resendSurveyTo, "document") ? "a:" : "la división:"}
            `}
            <strong>{resendSurveyTo.full_name || resendSurveyTo.name}</strong>?
          </span>
          <p style={{ fontSize: 13, marginTop: 8, marginBottom: 0 }}>
            {`La acción no será revertible y se perderán
              ${has(resendSurveyTo, "document")
                ? "sus respuestas, si es que las hubieran."
                : "todas las respuestas de los colaboradores dentro, si es que las hubieran."
              }
            `}
          </p>
        </Modal>
      </Fragment>
    )
  }
}

MeasurementDetailsTable.propTypes = {}

export default MeasurementDetailsTable
